import React from 'react';

function Play () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path
        fill="#fff"
        d="M17.657 31.336a1.564 1.564 0 00.864 1.371 1.7 1.7 0 001.673 0l11.863-7.337a1.522 1.522 0 000-2.743l-11.863-7.282a1.7 1.7 0 00-1.673 0 1.563 1.563 0 00-.864 1.371v14.62z"
      />
      <circle cx="24" cy="24" r="23" stroke="#fff" strokeWidth="2" />
    </svg>
  );
}

export default Play;
